(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5557:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(2711);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ HomePage; },
  "dynamic": function() { return /* binding */ dynamic; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./services/api.js + 41 modules
var api = __webpack_require__(8382);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/components/home/call-to-action.js


function HomeCallToAction() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "ds-call-to-action ptb-120 position-relative overflow-hidden z-1",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "gradient-overlay position-absolute start-0 top-0 w-100 h-100 z-1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/img/dealers/cta-bg.png",
                    alt: "not found",
                    fill: true,
                    style: {
                        objectFit: "cover",
                        objectPosition: "right center",
                        zIndex: -1
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "/img/shapes/offer-road.png",
                    alt: "not found",
                    width: 470,
                    height: 598,
                    sizes: "100vw",
                    quality: 100,
                    style: {
                        position: "absolute",
                        left: "0px",
                        top: "0px",
                        zIndex: 1
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row justify-content-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-xl-7 col-lg-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "section-content text-center position-relative z-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "h1 text-white mb-3",
                                        children: "Fazemos Os Melhores Neg\xf3cios"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-5 text-white",
                                        children: "Buscamos sempre a excel\xeancia em nossas negocia\xe7\xf5es tanto na compra como na venda de ve\xedculos. A satisfa\xe7\xe3o do cliente \xe9 nosso maior objetivo."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "cta-btns-wrapper d-flex align-items-center justify-content-center flex-wrap",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/estoque",
                                                className: "btn header-white-btn",
                                                children: "Ver Estoque Completo"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                href: "/venda-seu-veiculo",
                                                className: "btn header-white-btn",
                                                children: "Venda Seu Ve\xedculo"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(7536);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(2546);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(9901);
;// CONCATENATED MODULE: ./src/components/home/hero.js







function HomeHero(param) {
    let { banners  } = param;
    const router = (0,next_router.useRouter)();
    const { handleSubmit , register  } = (0,index_esm/* useForm */.cI)();
    const [filters, setFilters] = (0,react.useState)({
        isLoading: true,
        brands: [],
        models: [],
        yearsModel: [],
        transmissions: [],
        fuels: []
    });
    (0,react.useEffect)(()=>{
        if (filters.isLoading) {
            (0,api/* fetchGetAdsFilters */.zn)({
                condition: null
            }).then((res)=>{
                if (res) {
                    setFilters({
                        isLoading: false,
                        ...res
                    });
                }
            }).catch(()=>{
                setFilters({
                    ...filters,
                    isLoading: false
                });
            });
        }
    }, [
        filters
    ]);
    const onSubmit = (data)=>{
        if (data.ddlBrand) router.query.marca = data.ddlBrand;
        if (data.ddlModel) router.query.modelo = data.ddlModel;
        if (data.ddlPriceFrom) router.query.preco_de = data.ddlPriceFrom;
        if (data.ddlPriceTo) router.query.preco_ate = data.ddlPriceTo;
        router.push("/estoque?".concat(new URLSearchParams(router.query)));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            banners.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                className: "dealership-hero position-relative overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* Swiper */.tq, {
                    autoplay: true,
                    loop: true,
                    speed: 1500,
                    effect: "fade",
                    fadeEffect: {
                        crossFade: true
                    },
                    pagination: {
                        clickable: true
                    },
                    modules: [
                        swiper_esm/* Pagination */.tl,
                        swiper_esm/* EffectFade */.xW,
                        swiper_esm/* Autoplay */.pt
                    ],
                    children: banners.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "dl-hero-single",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "at_hero_slider",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "at-hero-banner",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: item.banner.imageUrl,
                                            alt: "banner",
                                            className: "at_hero_car"
                                        })
                                    })
                                })
                            })
                        }, index))
                })
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "at-search-box overflow-hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-lg-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "at-search-box-filter bg-white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "tab-content",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        className: "at-search-filter d-flex align-items-center",
                                        onSubmit: handleSubmit(onSubmit),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "input-field",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        children: "Marca"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                        className: "form-select",
                                                        ...register("ddlBrand"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: ""
                                                            }),
                                                            filters.brands.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                    value: item.name,
                                                                    children: item.name
                                                                }, index))
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "input-field",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        children: "Modelo"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                        className: "form-select",
                                                        ...register("ddlModel"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: ""
                                                            }),
                                                            filters.models.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                    value: item.name,
                                                                    children: item.name
                                                                }, index))
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "input-field",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        children: "Valor De"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                        className: "form-select",
                                                        ...register("ddlPriceFrom"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: ""
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "10000",
                                                                children: "R$ 10.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "20000",
                                                                children: "R$ 20.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "30000",
                                                                children: "R$ 30.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "40000",
                                                                children: "R$ 40.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "50000",
                                                                children: "R$ 50.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "60000",
                                                                children: "R$ 60.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "70000",
                                                                children: "R$ 70.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "80000",
                                                                children: "R$ 80.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "90000",
                                                                children: "R$90.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "100000",
                                                                children: "R$ 100.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "200000",
                                                                children: "R$ 200.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "300000",
                                                                children: "R$ 300.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "400000",
                                                                children: "R$ 400.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "500000",
                                                                children: "R$ 500.000,00"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "input-field",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                        children: "Valor At\xe9"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", {
                                                        className: "form-select",
                                                        ...register("ddlPriceTo"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: ""
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "10000",
                                                                children: "R$ 10.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "20000",
                                                                children: "R$ 20.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "30000",
                                                                children: "R$ 30.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "40000",
                                                                children: "R$ 40.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "50000",
                                                                children: "R$ 50.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "60000",
                                                                children: "R$ 60.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "70000",
                                                                children: "R$ 70.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "80000",
                                                                children: "R$ 80.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "90000",
                                                                children: "R$90.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "100000",
                                                                children: "R$ 100.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "200000",
                                                                children: "R$ 200.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "300000",
                                                                children: "R$ 300.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "400000",
                                                                children: "R$ 400.000,00"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                                                value: "500000",
                                                                children: "R$ 500.000,00"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "submit-btn align-self-end",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "btn btn-secondary btn-md",
                                                    type: "submit",
                                                    children: "Buscar Agora"
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/home/last-offers.js
var last_offers = __webpack_require__(5587);
;// CONCATENATED MODULE: ./src/components/home/what-our-customer-says.js



function HomeWhatOurCustomerSays() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            className: "eq-feedback-section ptb-120",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "container",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row align-items-center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-xl-6 col-lg-9",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "section-title ps-sm-3 text-center text-lg-start",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                        className: "mb-2 text-eq-primary",
                                        children: "Excel\xeancia em Atendimento"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "mb-3",
                                        children: "Os Nossos Clientes Satisfeitos"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "mb-0",
                                        children: "Est\xe1 em nosso DNA dar o melhor atendimento aos nossos clientes, gerando a melhor experi\xeancia de compra de ve\xedculos do mercado."
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "py-5 px-sm-3",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                            speed: 1000,
                            loop: true,
                            autoplay: true,
                            slidesPerView: 3,
                            spaceBetween: 24,
                            pagination: {
                                el: ".eq-feedback-pagination",
                                type: "bullets",
                                clickable: true
                            },
                            breakpoints: {
                                [0]: {
                                    slidesPerView: 1
                                },
                                [768]: {
                                    slidesPerView: 2
                                },
                                [1200]: {
                                    slidesPerView: 3
                                }
                            },
                            modules: [
                                swiper_esm/* Pagination */.tl,
                                swiper_esm/* Autoplay */.pt
                            ],
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    className: "swiper-slide bg-white rounded overflow-hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "customerSaysDiv",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "../img/Clientes6.jpeg",
                                            className: "customerSays"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    className: "swiper-slide bg-white rounded overflow-hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "customerSaysDiv",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "../img/Clientes5.jpeg",
                                            className: "customerSays"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    className: "swiper-slide bg-white rounded overflow-hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "customerSaysDiv",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "../img/Clientes4.jpeg",
                                            className: "customerSays"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    className: "swiper-slide bg-white rounded overflow-hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "customerSaysDiv",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "../img/Clientes3.jpeg",
                                            className: "customerSays"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    className: "swiper-slide bg-white rounded overflow-hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "customerSaysDiv",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "../img/Clientes2.jpeg",
                                            className: "customerSays"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                    className: "swiper-slide bg-white rounded overflow-hidden",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "customerSaysDiv",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            src: "../img/Clientes1.jpeg",
                                            className: "customerSays"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./src/components/layout/footer.js
var footer = __webpack_require__(9432);
// EXTERNAL MODULE: ./src/components/layout/header.js
var header = __webpack_require__(392);
;// CONCATENATED MODULE: ./src/pages/index.js










var __N_SSP = true;
const dynamic = "force-dynamic";
function HomePage(param) {
    let { companyGeneralData , adsLastOffers , banners  } = param;
    companyGeneralData = JSON.parse(companyGeneralData);
    const [siteSettings, setSiteSettings] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,api/* fetchGetCompanySiteSettings */.XQ)().then((res)=>{
            res.facebookDomainVerificationCode ? setSiteSettings(res.facebookDomainVerificationCode) : null;
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "".concat(companyGeneralData.company.nickName.toUpperCase(), "Revenda de ve\xedculos multimarcas, novos e semi-novos em ").concat(companyGeneralData.company.city ? companyGeneralData.company.city : "", ". Ve\xedculos com proced\xeancia e garantia.")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: "https://bndv.com.br"
                    }),
                    siteSettings.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "facebook-domain-verification",
                        content: siteSettings
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "".concat(companyGeneralData.company.nickName.toUpperCase(), " - ").concat(companyGeneralData.company.city ? companyGeneralData.company.city : "", " ")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "main-wrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header/* default */.Z, {
                        company: companyGeneralData.company
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeHero, {
                        banners: banners
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(last_offers/* default */.Z, {
                        ads: adsLastOffers
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeCallToAction, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeWhatOurCustomerSays, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(footer/* default */.Z, {
                        company: companyGeneralData.company
                    })
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [959,333,536,297,822,587,774,888,179], function() { return __webpack_exec__(5557); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);